import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "cd3ff694-8cbf-4819-b204-47eb075b42ab",
    options: { image: `${config.ASSETS_URL}/04/16/task/task-2-item-1.svg` },
  },
  {
    id: "267b7647-200c-466e-9a56-f5e8059c7d0f",
    options: { image: `${config.ASSETS_URL}/04/16/task/task-2-item-2.svg` },
  },
  {
    id: "1cda9dfe-b75e-48af-84f8-40ff9fab5f1f",
    options: { image: `${config.ASSETS_URL}/04/16/task/task-2-item-3.svg` },
  },
  {
    id: "c490bca1-7371-4065-a48b-249fdb465bd2",
    options: { image: `${config.ASSETS_URL}/04/16/task/task-2-item-4.svg` },
  },
];

export const task: Task = {
  id: "f1346351-1982-4124-a159-5ab216fabac9",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    columns: 2,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["cd3ff694-8cbf-4819-b204-47eb075b42ab"],
};
